import { Ref, MutableRefObject, RefObject, useState } from "react";
import { FormikProps } from "formik";

import SimpleInput from "../input/SimpleInput";
import Button from "../button/Button";
import FORMS from "../constants/forms";

import styles from "./discountCodeForm.module.css";

interface Props {
  handleApply?: ({ code }: { code: string }) => void;
  formSubmitRef?:
    | MutableRefObject<FormikProps<object>>
    | Ref<FormikProps<object>>
    | RefObject<FormikProps<object>>;
  onChange?: (value: FormikProps<object>) => void;
}

const DiscountCodeForm: React.FC<Props> = ({
  handleApply,
  formSubmitRef,
  onChange,
}) => {
  const [error, setError] = useState(null);

  const formData = {
    ...FORMS.DISCOUNTCODE,
    handleSubmit: handleApply ? handleApply : () => null,
    innerRef: formSubmitRef,
  };

  return (
    <>
      <SimpleInput data={formData} onChange={onChange} />
      {error && <div className={styles.error}>{error}</div>}
    </>
  );
};

export default DiscountCodeForm;
